var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3337 16.0001C21.3337 18.9456 18.9458 21.3334 16.0003 21.3334C13.0548 21.3334 10.667 18.9456 10.667 16.0001C10.667 13.0546 13.0548 10.6667 16.0003 10.6667C18.9458 10.6667 21.3337 13.0546 21.3337 16.0001ZM18.667 16.0001C18.667 17.4728 17.4731 18.6667 16.0003 18.6667C14.5276 18.6667 13.3337 17.4728 13.3337 16.0001C13.3337 14.5273 14.5276 13.3334 16.0003 13.3334C17.4731 13.3334 18.667 14.5273 18.667 16.0001Z",
    fill: "#00182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0707 4.14085C21.619 3.23742 20.6956 2.66675 19.6856 2.66675H12.3151C11.305 2.66675 10.3817 3.23742 9.92994 4.14084L9.33366 5.33341H5.33366C3.8609 5.33341 2.66699 6.52732 2.66699 8.00008V24.0001C2.66699 25.4728 3.8609 26.6667 5.33366 26.6667H26.667C28.1397 26.6667 29.3337 25.4728 29.3337 24.0001V8.00008C29.3337 6.52732 28.1397 5.33341 26.667 5.33341H22.667L22.0707 4.14085ZM5.33366 8.00008H10.9817L12.3151 5.33341H19.6856L21.0189 8.00008H26.667V24.0001H5.33366V8.00008Z",
    fill: "#00182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.c11d36ff4acc1957fbd363ee2af26631.svg";
export { ForwardRef as ReactComponent };